import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';

import { StoreLogo, StoreLogoVariant } from 'src/components/store-logo';
import { StoreRatingAverage } from '../store-rating-average';

import { trackShopLogoClick } from '../../tracking';

import { SHOP_LOGO_WIDTH } from 'src/areas/store/constants';

import { StoreInfo, StoreInfoTitle, InfoGroup } from './styles';
import { CountryBadge } from '../stock-price-info/country-badge';
import { ViewSize } from '../../types';

export const StoreInfoColumn = () => {
  const {
    isFeatured = false,
    offer,
    viewSize,
    isInPriceList,
  } = usePriceRowContext();
  const { store, isInternationalPrice } = offer;

  if (!store) {
    return null;
  }

  const handleShopLogoClick = () => trackShopLogoClick(store.id);

  const highResolutionLogo = store.logo
    ? { url: store.logo, width: SHOP_LOGO_WIDTH }
    : null;
  return (
    <StoreInfo role="none" onClick={handleShopLogoClick}>
      <StoreInfoTitle>{store.name}</StoreInfoTitle>
      <StoreLogo
        featured={isFeatured}
        hasImage={Boolean(store.hasLogo)}
        logoUrl={highResolutionLogo?.url}
        name={store.name}
        showHighResolutionLogo={Boolean(highResolutionLogo)}
        storeId={store.id}
        variant={StoreLogoVariant.PRICE_LIST}
        width={highResolutionLogo?.width}
      />

      <InfoGroup>
        {isInPriceList && <StoreRatingAverage />}
        {isInternationalPrice &&
          store?.primaryMarket &&
          viewSize === ViewSize.SMALL && (
            <CountryBadge countryCode={store.primaryMarket} />
          )}
      </InfoGroup>
    </StoreInfo>
  );
};
